import { getProviderAnalyticsApiRequest } from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { Action, basicReducerStaleWhileRevalidate, StateStatus } from '../core';

export const GET_PROVIDER_ANALYTICS = { entity: 'GET_PROVIDER_ANALYTICS', action: Action.GET_ONE };

export const getProviderAnalytics =
  (silent = false) =>
  async dispatch =>
    execute(dispatch, () => getProviderAnalyticsApiRequest(), GET_PROVIDER_ANALYTICS, false, null, silent);

const analyticsReducer = basicReducerStaleWhileRevalidate(GET_PROVIDER_ANALYTICS);

export const providerAnalyticsReducers = {
  all: (state, action) => {
    const next = analyticsReducer(state, action);
    return next.status === StateStatus.ERROR && state?.data ? { ...next, data: state.data } : next;
  },
};
